import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-online-fees-payment',
  templateUrl: './online-fees-payment.component.html',
  styleUrls: ['./online-fees-payment.component.scss']
})
export class OnlineFeesPaymentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
